var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _path2, _g2, _g3, _g4, _path3, _g5, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStyleGlossary = function SvgStyleGlossary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 535 474"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_glossary_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 400,
    x: 93,
    y: 27,
    fill: "#fff",
    rx: 9.797
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 104.114,
    x: 115,
    y: 175.193,
    fill: "#fff",
    rx: 9.465
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 8,
    x: 115,
    y: 196,
    fill: "#EDEDED",
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 8,
    x: 115,
    y: 214,
    fill: "#EDEDED",
    rx: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 8,
    x: 115,
    y: 250,
    fill: "#EDEDED",
    rx: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 8,
    x: 315,
    y: 250,
    fill: "#EDEDED",
    rx: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 8,
    x: 115,
    y: 232,
    fill: "#EDEDED",
    rx: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 8,
    x: 281,
    y: 232,
    fill: "#EDEDED",
    rx: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 8,
    x: 326,
    y: 232,
    fill: "#EDEDED",
    rx: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 8,
    x: 247,
    y: 214,
    fill: "#EDEDED",
    rx: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 314.818,
    height: 122.818,
    x: 115.591,
    y: 51.591,
    fill: "#fff",
    stroke: "#51C394",
    strokeWidth: 1.182,
    rx: 8.864
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 284.091,
    height: 11.818,
    x: 130.78,
    y: 85.182,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 110.479,
    height: 11.818,
    x: 130.78,
    y: 106.454,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 170.982,
    height: 11.818,
    x: 130.78,
    y: 149,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 102.589,
    height: 11.818,
    x: 312.286,
    y: 149,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 140.73,
    height: 11.818,
    x: 130.78,
    y: 127.727,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 31.566,
    height: 11.818,
    x: 282.036,
    y: 127.728,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 90.752,
    height: 11.818,
    x: 324.124,
    y: 127.728,
    fill: "#E2FFEA",
    rx: 5.909
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 163.09,
    height: 11.818,
    x: 251.785,
    y: 106.454,
    fill: "#E2FFEA",
    rx: 5.909
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M131.91 71.088v-1.484h7.126v1.484zm2.772-4.312h1.582v7.154h-1.582zm11.193 4.074q.321.56.686.994.378.42.826.658.447.225 1.008.224.672 0 1.092-.364t.42-.938q0-.546-.266-.868a2 2 0 0 0-.742-.56 9 9 0 0 0-1.078-.462 8 8 0 0 1-.812-.336 5 5 0 0 1-.854-.546 2.8 2.8 0 0 1-.672-.812q-.266-.49-.266-1.176 0-.784.406-1.372.405-.602 1.092-.924.7-.336 1.582-.336.867 0 1.512.308.643.308 1.078.784.448.476.7.994l-1.344.756a3 3 0 0 0-.462-.672 2 2 0 0 0-.658-.504 1.8 1.8 0 0 0-.854-.196q-.687 0-1.008.322a.97.97 0 0 0-.322.728q0 .377.224.686.237.294.728.56.49.266 1.274.546.433.154.868.392.447.239.812.602.363.35.574.826.224.475.224 1.12 0 .686-.266 1.232t-.728.924q-.462.365-1.05.56-.574.21-1.204.21a3.85 3.85 0 0 1-1.61-.336 4.3 4.3 0 0 1-1.274-.924 4.8 4.8 0 0 1-.868-1.246zm6.441-3.29h3.654v1.33h-3.654zm1.078-2.24h1.498V74h-1.498zm9.317 2.24-4.2 9.52h-1.61l1.68-3.836-2.59-5.684h1.736l2.058 5.096-.714-.042 2.016-5.054zm.905-4.48h1.512V74h-1.512zm6.246 11.06q-.98 0-1.736-.42a2.9 2.9 0 0 1-1.148-1.176q-.406-.756-.406-1.764 0-1.022.406-1.778.42-.756 1.176-1.162.755-.42 1.778-.42 1.022 0 1.736.392t1.092 1.134q.392.727.392 1.764 0 .112-.014.238a1 1 0 0 1-.014.182h-5.656v-1.036h4.368l-.462.644q.042-.084.084-.224a.8.8 0 0 0 .056-.252q0-.518-.21-.896a1.42 1.42 0 0 0-.56-.588 1.6 1.6 0 0 0-.826-.21q-.575 0-.98.252a1.6 1.6 0 0 0-.616.728q-.21.476-.224 1.176 0 .7.21 1.19.21.476.616.728.42.252 1.008.252.615 0 1.078-.252.462-.252.77-.77l1.302.532q-.504.868-1.302 1.302-.799.435-1.918.434m13.718-3.864v-1.4h4.718a6.1 6.1 0 0 1-.28 2.044 5.1 5.1 0 0 1-.924 1.694q-.615.743-1.54 1.176-.91.42-2.072.42a5.6 5.6 0 0 1-2.044-.364 5 5 0 0 1-1.638-1.064 4.8 4.8 0 0 1-1.064-1.624 5.5 5.5 0 0 1-.378-2.058q0-1.12.378-2.044a4.85 4.85 0 0 1 1.078-1.61 4.8 4.8 0 0 1 1.638-1.05 5.7 5.7 0 0 1 2.058-.364q.966 0 1.75.266.785.252 1.4.742.63.476 1.064 1.162l-1.344.896a3.03 3.03 0 0 0-1.134-1.12q-.713-.42-1.736-.42-.951 0-1.722.448-.77.435-1.232 1.232-.462.784-.462 1.862 0 1.065.448 1.876.462.798 1.232 1.246a3.4 3.4 0 0 0 1.736.448q.659 0 1.176-.182a2.7 2.7 0 0 0 .896-.518q.378-.335.63-.77.252-.434.378-.924zm7.84 1.204q0 .686.294 1.064t.896.378q.435 0 .756-.168.323-.182.504-.504.183-.336.182-.77v-3.92h1.512V74h-1.512v-.994a2.2 2.2 0 0 1-.798.854q-.476.28-1.148.28-1.077 0-1.666-.672-.574-.672-.574-1.82V67.56h1.554zm6.019-6.482q0-.391.28-.658a.97.97 0 0 1 .672-.266.9.9 0 0 1 .672.266.87.87 0 0 1 .28.658.9.9 0 0 1-.28.658.9.9 0 0 1-.672.266.97.97 0 0 1-.672-.266.9.9 0 0 1-.28-.658m.21 2.562h1.484V74h-1.484zm8.409-4.48h1.526V74h-1.526zm-5.334 7.7q0-1.064.434-1.806a2.95 2.95 0 0 1 1.148-1.148 3.14 3.14 0 0 1 1.554-.406q.812 0 1.414.406.617.405.966 1.162.364.742.364 1.792 0 1.035-.364 1.792-.35.756-.966 1.162-.602.406-1.414.406-.826 0-1.554-.392a3.05 3.05 0 0 1-1.148-1.162q-.434-.756-.434-1.806m1.568 0q0 .645.266 1.106t.7.7q.448.238.966.238.434 0 .854-.238.434-.238.7-.686.28-.462.28-1.12t-.28-1.106a1.8 1.8 0 0 0-.7-.7 1.7 1.7 0 0 0-.854-.238q-.518 0-.966.238a1.8 1.8 0 0 0-.7.7q-.266.462-.266 1.106m9.966 3.36q-.98 0-1.736-.42a2.9 2.9 0 0 1-1.148-1.176q-.406-.756-.406-1.764 0-1.022.406-1.778.42-.756 1.176-1.162.756-.42 1.778-.42t1.736.392 1.092 1.134q.392.727.392 1.764 0 .112-.014.238a.8.8 0 0 1-.014.182h-5.656v-1.036h4.368l-.462.644q.042-.084.084-.224a.8.8 0 0 0 .056-.252q0-.518-.21-.896a1.4 1.4 0 0 0-.56-.588 1.57 1.57 0 0 0-.826-.21q-.573 0-.98.252-.405.252-.616.728t-.224 1.176q0 .7.21 1.19.21.476.616.728.42.252 1.008.252.616 0 1.078-.252t.77-.77l1.302.532q-.504.868-1.302 1.302t-1.918.434"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 314.818,
    height: 122.818,
    x: 115.591,
    y: 278.591,
    fill: "#fff",
    stroke: "#3B7CC9",
    strokeWidth: 1.182,
    rx: 8.864
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 284.091,
    height: 11.818,
    x: 130.78,
    y: 312.182,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 110.479,
    height: 11.818,
    x: 130.78,
    y: 333.454,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 170.982,
    height: 11.818,
    x: 130.78,
    y: 376,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 102.589,
    height: 11.818,
    x: 312.286,
    y: 376,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 140.73,
    height: 11.818,
    x: 130.78,
    y: 354.727,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 31.566,
    height: 11.818,
    x: 282.036,
    y: 354.728,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 90.752,
    height: 11.818,
    x: 324.124,
    y: 354.728,
    fill: "#E3F3FF",
    rx: 5.909
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 163.09,
    height: 11.818,
    x: 251.785,
    y: 333.454,
    fill: "#E3F3FF",
    rx: 5.909
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M131.91 298.088v-1.484h7.126v1.484zm2.772-4.312h1.582v7.154h-1.582zm15.211 3.5v-1.4h4.718a6.2 6.2 0 0 1-.28 2.044 5.1 5.1 0 0 1-.924 1.694 4.4 4.4 0 0 1-1.54 1.176q-.91.42-2.072.42a5.6 5.6 0 0 1-2.044-.364 5 5 0 0 1-1.638-1.064 4.8 4.8 0 0 1-1.064-1.624 5.5 5.5 0 0 1-.378-2.058q0-1.12.378-2.044a4.8 4.8 0 0 1 1.078-1.61 4.8 4.8 0 0 1 1.638-1.05 5.7 5.7 0 0 1 2.058-.364q.966 0 1.75.266.783.252 1.4.742.63.476 1.064 1.162l-1.344.896a3.04 3.04 0 0 0-1.134-1.12q-.714-.42-1.736-.42-.952 0-1.722.448-.77.434-1.232 1.232-.462.784-.462 1.862 0 1.064.448 1.876.461.798 1.232 1.246a3.4 3.4 0 0 0 1.736.448q.657 0 1.176-.182t.896-.518.63-.77.378-.924zm6.286-7.196h1.512V301h-1.512zm2.955 7.7q0-.994.448-1.75a3.2 3.2 0 0 1 1.246-1.176q.785-.434 1.778-.434.995 0 1.764.434.784.42 1.246 1.176t.462 1.75q0 .98-.462 1.75a3.3 3.3 0 0 1-1.246 1.19q-.77.42-1.764.42-.993 0-1.778-.42a3.3 3.3 0 0 1-1.246-1.19q-.448-.77-.448-1.75m1.554 0q0 .602.252 1.064.252.448.686.714.434.252.98.252.532 0 .966-.252.448-.266.7-.714.252-.462.252-1.064t-.252-1.064a1.8 1.8 0 0 0-.7-.714 1.9 1.9 0 0 0-.966-.252q-.546 0-.98.252a1.8 1.8 0 0 0-.686.714 2.2 2.2 0 0 0-.252 1.064m7.119 1.106q.308.336.616.588.322.238.644.364.322.112.644.112.406 0 .63-.182a.6.6 0 0 0 .238-.504.68.68 0 0 0-.182-.476 1.4 1.4 0 0 0-.504-.35 8 8 0 0 0-.756-.308 9 9 0 0 1-.868-.392 2.2 2.2 0 0 1-.7-.616q-.266-.378-.266-.952 0-.588.294-.98a1.77 1.77 0 0 1 .812-.574 3.1 3.1 0 0 1 1.106-.196q.532 0 .994.154.476.154.854.406t.644.574l-.84.896a2.6 2.6 0 0 0-.77-.616 1.94 1.94 0 0 0-.924-.238.94.94 0 0 0-.532.14.46.46 0 0 0-.21.406q0 .224.182.406.197.168.504.308.323.14.714.294.532.21.98.462.449.252.714.616.28.364.28.952 0 .91-.63 1.47-.617.546-1.68.546-.658 0-1.218-.196a3.8 3.8 0 0 1-.966-.532 4.4 4.4 0 0 1-.686-.7zm5.933 0q.309.336.616.588.323.238.644.364.323.112.644.112.406 0 .63-.182a.6.6 0 0 0 .238-.504.67.67 0 0 0-.182-.476 1.4 1.4 0 0 0-.504-.35 8 8 0 0 0-.756-.308 9 9 0 0 1-.868-.392 2.2 2.2 0 0 1-.7-.616q-.266-.378-.266-.952 0-.588.294-.98.309-.392.812-.574a3.1 3.1 0 0 1 1.106-.196q.532 0 .994.154.477.154.854.406.378.252.644.574l-.84.896a2.6 2.6 0 0 0-.77-.616 1.94 1.94 0 0 0-.924-.238.94.94 0 0 0-.532.14.46.46 0 0 0-.21.406q0 .224.182.406.197.168.504.308.322.14.714.294.533.21.98.462.448.252.714.616.28.364.28.952 0 .91-.63 1.47-.615.546-1.68.546a3.7 3.7 0 0 1-1.218-.196 3.8 3.8 0 0 1-.966-.532 4.4 4.4 0 0 1-.686-.7zm6.592.112q0 .322.154.56a.95.95 0 0 0 .42.336q.28.112.63.112.448 0 .812-.182.378-.182.602-.532a1.5 1.5 0 0 0 .238-.84l.224.84q0 .616-.364 1.036a2.2 2.2 0 0 1-.896.616 3.1 3.1 0 0 1-1.092.196q-.602 0-1.12-.238a1.95 1.95 0 0 1-.826-.7q-.308-.462-.308-1.12 0-.938.658-1.484.658-.56 1.862-.56.644 0 1.106.14.476.14.784.336.308.181.434.336v.77a3 3 0 0 0-.924-.448 3.8 3.8 0 0 0-1.036-.14q-.476 0-.77.126a.97.97 0 0 0-.448.322.9.9 0 0 0-.14.518m-.476-2.758-.616-1.064q.434-.266 1.12-.518.7-.252 1.596-.252.798 0 1.4.238.617.238.966.686.35.434.35 1.078V301h-1.484v-4.298q0-.308-.112-.504a.84.84 0 0 0-.28-.322 1.2 1.2 0 0 0-.434-.182 2.5 2.5 0 0 0-.546-.056q-.448 0-.854.112-.392.097-.686.252a3.5 3.5 0 0 0-.42.238m8.077-1.68V301h-1.498v-6.44zm1.918 1.61a2 2 0 0 0-.392-.252 1.1 1.1 0 0 0-.462-.084q-.378 0-.616.196a1.13 1.13 0 0 0-.35.546q-.099.336-.098.798l-.504-.294q0-.77.28-1.358.294-.602.742-.952.462-.35.952-.35.35 0 .658.112.308.098.518.364zm7.887-1.61-4.2 9.52h-1.61l1.68-3.836-2.59-5.684h1.736l2.058 5.096-.714-.042 2.016-5.054z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_glossary_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M469.517 338.6c0-8.961 0-13.441-1.744-16.864a16 16 0 0 0-6.992-6.992C457.359 313 452.878 313 443.917 313h-8.318c-8.961 0-13.441 0-16.864 1.744a16 16 0 0 0-6.992 6.992c-1.744 3.423-1.744 7.903-1.744 16.864v8.318c0 8.961 0 13.442 1.744 16.864a16 16 0 0 0 6.992 6.992c3.423 1.744 7.903 1.744 16.864 1.744h8.318c8.961 0 13.442 0 16.864-1.744a16 16 0 0 0 6.992-6.992c1.744-3.422 1.744-7.903 1.744-16.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M426.999 331.571h25v26.786H430.57a3.57 3.57 0 0 1-3.571-3.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M426.999 331.571A3.57 3.57 0 0 1 430.57 328h21.429v7.143H430.57a3.57 3.57 0 0 1-3.571-3.572"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M443.068 344.071v-8.928h5.357v8.928l-2.678-2.678z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_glossary_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M126.518 110.6c0-8.961 0-13.441-1.744-16.864a16 16 0 0 0-6.992-6.992C114.36 85 109.879 85 100.918 85H92.6c-8.96 0-13.441 0-16.864 1.744a16 16 0 0 0-6.992 6.992C67 97.16 67 101.64 67 110.6v8.318c0 8.961 0 13.442 1.744 16.864a16 16 0 0 0 6.992 6.992c3.423 1.744 7.903 1.744 16.864 1.744h8.318c8.961 0 13.442 0 16.864-1.744a16 16 0 0 0 6.992-6.992c1.744-3.422 1.744-7.903 1.744-16.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M98.858 98H87.715A3.714 3.714 0 0 0 84 101.714v26a3.714 3.714 0 0 0 3.715 3.715h18.571a3.714 3.714 0 0 0 3.714-3.715v-18.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9FFDC",
    d: "M98.86 109.143V98l11.142 11.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.572 116.571c0-1.025.832-1.857 1.857-1.857h11.143a1.857 1.857 0 0 1 0 3.715H91.429a1.86 1.86 0 0 1-1.857-1.858M89.572 124c0-1.026.832-1.857 1.857-1.857h11.143a1.856 1.856 0 1 1 0 3.714H91.429A1.857 1.857 0 0 1 89.572 124"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_glossary_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#FFB800",
    rx: 16,
    transform: "matrix(-1 0 0 1 103.518 346)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m87.66 379.093-2.796-2.187c.035-.337.065-.731.065-1.148s-.029-.811-.066-1.148l2.8-2.188c.519-.411.66-1.14.33-1.747l-2.908-5.031c-.31-.567-.99-.859-1.682-.604l-3.3 1.324a11.3 11.3 0 0 0-1.98-1.149l-.502-3.5a1.346 1.346 0 0 0-1.344-1.166h-5.83c-.684 0-1.26.502-1.342 1.156l-.503 3.512c-.664.299-1.317.68-1.977 1.15l-3.309-1.329c-.62-.239-1.36.03-1.669.595l-2.911 5.037a1.36 1.36 0 0 0 .33 1.756l2.795 2.186c-.044.427-.066.799-.066 1.147 0 .349.022.72.066 1.149l-2.798 2.188c-.52.411-.66 1.14-.33 1.746l2.908 5.031c.31.567.985.861 1.682.605l3.3-1.325a11.4 11.4 0 0 0 1.98 1.15l.501 3.498c.082.667.66 1.169 1.344 1.169h5.83c.684 0 1.262-.502 1.343-1.156l.503-3.511c.664-.301 1.316-.68 1.977-1.151l3.309 1.328q.24.094.496.094c.492 0 .945-.269 1.173-.687l2.92-5.057a1.37 1.37 0 0 0-.34-1.737m-14.298 1.737a5.075 5.075 0 0 1-5.07-5.071 5.075 5.075 0 0 1 5.07-5.07 5.075 5.075 0 0 1 5.07 5.07 5.075 5.075 0 0 1-5.07 5.071"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#style_glossary_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.422,
    height: 52.422,
    fill: "#3BBDCF",
    rx: 11.744,
    transform: "matrix(-1 0 0 1 498.422 39)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFEFE",
    fillRule: "evenodd",
    d: "M474.708 53.562h-4.992v9.153h-9.154v4.992h9.154v9.153h4.992v-9.153h9.153v-4.992h-9.153z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "style_glossary_svg__a",
    width: 433.477,
    height: 473.477,
    x: 56.261,
    y: 0.261,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.369
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_glossary_svg__b",
    width: 107.519,
    height: 107.518,
    x: 385.999,
    y: 299,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_glossary_svg__c",
    width: 107.518,
    height: 107.518,
    x: 43,
    y: 71,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_glossary_svg__d",
    width: 152.102,
    height: 152.102,
    x: 0.353,
    y: 310.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "style_glossary_svg__e",
    width: 120.376,
    height: 120.376,
    x: 413.964,
    y: 12.789,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.942,
    dy: 7.766
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.989
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_696_60988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_696_60988",
    result: "shape"
  })))));
};
export default SvgStyleGlossary;